<template>
    <div v-loading="loading.page" class="new-object-detail" title="对象详情">
        <div v-if="objectInfo.id" class="object-info">
            <div class="info-title">
                基本信息
            </div>
            <div class="info-content">
                <div v-for="info in objectInfoMap" :key="info.key" :class="['info-item', {remark: info.key === 'remark'}]">
                    <h4>{{ info.title }}：</h4>
                    <p>
                        {{ objectInfo[info.key] }}
                    </p>
                </div>
            </div>
        </div>
        <div class="new-object__group info-title">
            <div>
                字段
            </div>
            <div v-if="isTenantApp ? !isTenantObject ? validPurviewObject.addField : fromObjectCustomizeRoute : fromObjectCustomizeRoute" class="new-object__group__btn">
                <hc-button :disabled="!isDevEnv || isSystem" icon="el-icon-plus" type="primary" @click="openDialogFn('添加')">
                    添加字段
                </hc-button>
                <!-- <span class="new-object__group__btn--add" >添加字段</span> -->
            </div>
        </div>
        <hc-table ref="elTable" :data="objectFieldArr" class="custom-table stripe">
            <paas-empty slot="empty">
                <div v-if="isTenantApp ? !isTenantObject ? validPurviewObject.addField : true : true" slot="tip" class="tip">
                    暂无字段，
                    <span @click="openDialogFn('添加')">立即添加</span>
                </div>
            </paas-empty>
            <hc-table-column label="序号" type="index" width="60" />
            <hc-table-column label="显示名称" prop="title" />
            <hc-table-column label="字段 ID" prop="name" />
            <hc-table-column
                prop="type"
                label="字段类型"
                width="200"
            >
                <template slot-scope="{ row }">
                    <span>{{ row.type !== 'object' ? (DefaultType.find(item => item.type === getType(row.type)).title || '--') : '对象' }}</span>
                    <a v-if="row.relatedObject && row.relatedObject.title"
                        style="color:#2A6AFF;cursor:pointer" @click="objectDetailFn(row.relatedObject)"
                    >（{{ (row.relatedObject || {}).title }}）</a>
                </template>
            </hc-table-column>
            <hc-table-column label="输入组件" prop="config.defaultComponent">
                <template slot-scope="{ row }">
                    <span>{{ ComponentsMap[row.config.defaultComponent] }}</span>
                </template>
            </hc-table-column>
            <hc-table-column label="校验规则" prop="config.required">
                <template slot-scope="{ row }">
                    <span>{{ row.config.required?"必填":"非必填" }}</span>
                </template>
            </hc-table-column>
            <!-- <hc-table-column label="高级配置" prop="configDescStr" /> -->
            <!-- <hc-table-column
                v-for="(item,index) in columns"
                :key="item.prop + index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width === 'min-width' ? 'auto' :item.width"
                :min-width="item.width === 'min-width' ? '200' : 'auto'"
            >
                <template slot-scope="{ row }">
                    <span>{{ row[item.prop] !== 'object' ? (row[item.prop] || '--') : '对象' }}</span>
                    <a v-if="item.prop === 'type' && row.relatedObject && row.relatedObject.title"
                        style="color:#2A6AFF;cursor:pointer" @click="objectDetailFn(row.relatedObject)"
                    >（{{ (row.relatedObject || {}).title }}）</a>
                </template>
            </hc-table-column> -->
            <hc-table-column v-if="fromObjectCustomizeRoute" label="操作" width="110" fixed="right">
                <template slot-scope="{ row }">
                    <hc-button v-if="isTenantApp ? row.isTenant : true" type="text" :disabled="!isDevEnv || row.isSystem" @click="openDialogFn('编辑',row)">
                        编辑
                    </hc-button>
                    <hc-button v-if="isTenantApp ? row.isTenant : true" type="text" :disabled="!isDevEnv || row.isSystem" @click="delObjectFieldFn(row)">
                        删除
                    </hc-button>
                </template>
            </hc-table-column>
        </hc-table>
        <hc-dialog v-if="varObj.optBool" :close-on-click-modal="false" :model="apiParamObj" :title="`${varObj.optType}字段`" width="720px" :visible.sync="varObj.optBool" @close="cancel">
            <hc-form ref="form" v-loading="dialogLoading" :rules="rulesObj" label-position="left" label-width="100px" :model="apiParamObj">
                <hc-form-item
                    label="名称"
                    prop="title"
                >
                    <hc-input v-model.trim="apiParamObj.title" type="text" placeholder="请输入字段名称" size="small" />
                </hc-form-item>
                <hc-form-item
                    label="ID"
                    prop="name"
                >
                    <hc-input v-model.trim="apiParamObj.name" type="text" placeholder="请输入字段 ID" size="small">
                        <template v-if="isTenantApp && !isTenantObject" :slot="apiParamObj.customizeType === 0 ? 'prepend' : 'append'">
                            {{ apiParamObj.customizeField }}
                        </template>
                    </hc-input>
                </hc-form-item>
                <hc-form-item
                    label="类型"
                    prop="type"
                    :rules="[
                        { required: true, message: '请选择字段类型', trigger: ['blur'] },
                    ]"
                >
                    <hc-select v-model.trim="currentType" placeholder="请选择" size="small" @change="changeFieldTypeFn">
                        <hc-option
                            v-for="item in typeArr"
                            :key="item.type"
                            :label="item.title"
                            :value="item.type"
                        />
                    </hc-select>
                </hc-form-item>
                <!-- 根据不同 type 渲染不同的配置 -->
                <object-detail-type-form
                    ref="objectDetailTypeForm"
                    v-model="apiParamObj.config"
                    :field-type="apiParamObj.type"
                    :opt-type="varObj.optType"
                />
                <hc-form-item
                    v-if="apiParamObj.type === 'object' || apiParamObj.type === 'objectArray'"
                    :key="apiParamObj.type + apiParamObj.objectName"
                    label="业务对象"
                    prop="typeObjectId"
                    :rules="[
                        { required: true, message: '请选择业务对象', trigger: ['blur'] },
                    ]"
                >
                    <!-- <object-picker v-if="varObj.optType === '编辑'" v-model="apiParamObj.objectId" :object-name.sync="apiParamObj.objectName" />
                    <object-picker v-else v-model="apiParamObj.objectId" :object-name.sync="apiParamObj.objectName" /> -->
                    <object-picker v-model="apiParamObj.typeObjectId" :object-name.sync="apiParamObj.objectName" :business-env-id="businessEnvId" />
                </hc-form-item>
                <!-- <hc-form-item v-if="apiParamObj.type === 'string'" :key="apiParamObj.type" label="默认值" :rules="defaultValRules" prop="defaultValue">
                    <hc-input v-model="apiParamObj.defaultValue" :type="apiParamObj.type === 'string' ? 'text' : 'number'" placeholder="请输入默认值" size="small" />
                </hc-form-item>
                <hc-form-item v-if="apiParamObj.type === 'boolean'" :key="apiParamObj.type" label="默认值">
                    <hc-switch v-model="apiParamObj.defaultValue" :active-value="true" :inactive-value="false" />
                </hc-form-item>
                <hc-form-item v-if="['dateTime', 'date', 'time'].includes(apiParamObj.type)" :key="apiParamObj.type" label="默认值">
                    <hc-date-picker
                        v-if="apiParamObj.type === 'dateTime'"
                        v-model="apiParamObj.defaultValue"
                        value-format="yyyy-MM-dd hh:mm:ss"
                        size="small"
                        style="width:100%;"
                        type="datetime"
                        placeholder="选择日期时间"
                    />
                    <hc-date-picker
                        v-if="apiParamObj.type === 'date'"
                        v-model="apiParamObj.defaultValue"
                        value-format="yyyy-MM-dd"
                        size="small"
                        style="width:100%;"
                        type="date"
                        placeholder="选择日期"
                    />
                    <hc-time-picker
                        v-if="apiParamObj.type === 'time'"
                        v-model="apiParamObj.defaultValue"
                        value-format="hh:mm:ss"
                        size="small"
                        style="width:100%;"
                        type="time"
                        placeholder="选择时间"
                    />
                </hc-form-item> -->
            </hc-form>
            <div slot="footer">
                <hc-button type="plain" @click="cancel">
                    取消
                </hc-button>
                <hc-button :type="varObj.optType === '编辑' ? 'primary' : 'plain'" @click="varObj.optType === '添加' ? addObjectFieldFn() : editObjectFieldFn()">
                    保存
                </hc-button>
                <hc-button v-if="varObj.optType === '添加'" type="primary" @click="varObj.optType === '添加' ? addObjectFieldFn('holdDialog') : editObjectFieldFn('holdDialog')">
                    保存并新增
                </hc-button>
            </div>
        </hc-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as T from '@common/store/app-resource/types'
// import characterLength from '@common/utils/character-length'
import { APP_RESOURCE } from '@common/store/module-types'
import * as ST from '@common/store/types'
import ObjectDetailTypeForm from './object-detail-type-form'
import * as RouteNames from '../types'
import ObjectPicker from './object-picker'
import DataServiceMinxin from '../mixins/data-service'
import fieldMixin from './field-mixin'
import commonMinxin from '../mixins/commom'
import {
    STRING, DefaultType, ObjectFieldType, ComponentsMap, DefaultTypeValue,
} from './const'

export default {
    name: 'ObjectDetail',
    components: {
        ObjectPicker,
        ObjectDetailTypeForm,
    },
    mixins: [DataServiceMinxin, commonMinxin, fieldMixin],
    data() {
        return {
            varObj: {},
            DefaultType,
            typeArr: DefaultType,
            dialogLoading: false,
            columns: [
                {
                    prop: 'name',
                    label: '字段 ID',
                    width: '170',
                },
                {
                    prop: 'type',
                    label: '字段类型',
                    width: '180',
                },
                {
                    prop: 'config.defaultComponent',
                    label: '输入组件',
                    width: '190',
                },
                {
                    prop: 'config.required',
                    label: '校验规则',
                    width: '190',
                },
                {
                    prop: 'configDescStr',
                    label: '高级配置',
                    width: '190',
                },
            ],
            filterObj: {
                keyword: '',
                page: 1,
                pageSize: 20,
            },
            apiParamObj: {
                relatedObject: {},
            }, // 请求接口的参数
            objectFieldArr: [],
            objectArr: [],
            appId: '',
            businessEnvId: '',
            isDevEnv: false,
            isTenantObject: false,
            loading: {
                page: false,
                dialog: false,
            },
            objectInfo: {},
            objectInfoMap: [
                { title: '显示名称', key: 'title' },
                { title: '对象名称', key: 'name' },
                // { title: '对象 ID', key: 'name' },
                // { title: '备注', key: 'remark' },
            ],
            ComponentsMap,
            fromObjectCustomizeRoute: false,
        }
    },
    computed: {
        // 真实字段类型的抽象分类
        currentType: {
            get() {
                return this.getType(this.apiParamObj.type)
            },
            set(value) {
                this.apiParamObj.type = value
            },
        },
        isSystem() {
            return this.objectFieldArr.some(item => item.isSystem)
        },
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
        validPurviewObject() {
            return this.$store.state.modeling.validPurview.object || {}
        },
        appInfo() {
            return this.$store.state.modeling.app
        },
    },
    watch: {
        '$route'(to, from) {
            if ((!from || to.params.objectId !== from.params.objectId || to.params.objectName !== from.params.objectName)) {
                this.appId = to.params.appId || this.appId
                this.objectId = to.params.objectId
                this.getObjectFieldFn()
                // this.getGroupObjectFn();
                if (this.$route.query && this.$route.query.isTenant) {
                    this.isTenantObject = JSON.parse(this.$route.query.isTenant)
                }
            }
        },
        'apiParamObj.type'(val, oldV) {
            if (oldV && val && val !== oldV) {
                const {
                    name, title, type, defaultValue,
                } = this.apiParamObj
                this.apiParamObj = {
                    ...this.apiParamObj,
                    name,
                    title,
                    type,
                    defaultValue,
                }
                this.changeFieldTypeFn()
            }
            if (val !== 'object' && val !== 'objectArray') {
                delete this.apiParamObj.objectId
                delete this.apiParamObj.objectName
            }
            if (val === 'boolean' && this.varObj.optType === '添加') {
                this.apiParamObj.defaultValue = false
            }
        },
        'apiParamObj.config': {
            deep: true,
            handler(value) {
                if (!value) return
                this.$nextTick(() => {
                    this.apiParamObj.type = value.type
                })
            },
        },

    },
    mounted() {
        try {
            this.appId = this.$route.params.appId
            this.objectId = this.$route.params.objectId
            this.businessEnvId = this.$route.query.businessEnvId
            this.isDevEnv = this.$route.query.isDevEnv === 'true'
            this.isTenantObject = JSON.parse(this.$route.query.isTenant || false)
            this.fromObjectCustomizeRoute = this.$route.query.fromObjectCustomizeRoute === 'true'
            this.getObjectFieldFn()
            // this.getGroupObjectFn();
            // this.getObjectDtlFn()
        } catch (error) {
            // ignore
        }
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObjectField: T.GET_NEW_OBJECT_FIELD,
            addObjectField: T.ADD_NEW_OBJECT_FIELD,
            editObjectField: T.EDIT_NEW_OBJECT_FIELD,
            delObjectField: T.DEL_NEW_OBJECT_FIELD,
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
            checkCustomizeField: T.CHECK_CUSTOMIZE_FIELD,
            getPurviewObject: T.GET_PURVIEW_OBJECT,
        }),
        ...mapActions({
            getValidPurview: ST.GET_VALID_PURVIEW,
        }),
        cancel() {
            this.$refs.form.resetFields()
            this.apiParamObj = {
                relatedObject: {},
            }
            this.$set(this.varObj, 'optBool', false)
        },
        getType(cType) {
            return (ObjectFieldType.find(type => type.name === cType) || {}).type
        },
        // 未被调用，确认是否应该删除
        async getObjectDtlFn() {
            try {
                const resData = await this.getObjectDtl({
                    objectId: this.objectId,
                })
                this.$route.params.name = resData.title
                this.objectInfo = resData
                localStorage.setItem('new-object', resData.title)
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        // 查询分组中的对象列表
        async getGroupObjectFn(val) {
            try {
                const resData = await this.getObject({
                    keyword: val,
                })
                this.objectArr = (resData.items || []).filter(item => this.objectId !== item.id)
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        // 字段列表
        async getObjectFieldFn() {
            try {
                const resData = await this.getObjectField({
                    objectId: this.objectId,
                })
                this.objectFieldArr = (resData || {}).items || []
                this.$route.params.name = resData.title
                this.objectInfo = resData
                localStorage.setItem('new-object', resData.title)
                this.updateDesignerDataObjectList()
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        async openDialogFn(type, item) {
            this.$set(this.varObj, 'optBool', true)
            this.$set(this.varObj, 'optType', type)
            if (this.isTenantApp) {
                this.dialogLoading = true
                await this.getValidPurview({ appId: this.appId })
                this.dialogLoading = false
            }

            if (this.isTenantApp && !this.isTenantObject) {
                this.apiParamObj = {
                    customizeType: this.validPurviewObject.customizeType,
                    customizeField: this.validPurviewObject.customizeField,
                }
            }
            if (item) { // 编辑字段
                this.$set(this.varObj, 'fieldId', item.id)
                let reg = ''
                if (this.isTenantApp) {
                    if (item.customizeType === 0) {
                        reg = new RegExp(`^${item.customizeField}`)
                    } else {
                        reg = new RegExp(`${item.customizeField}$`)
                    }
                }

                this.apiParamObj = {
                    // name: item.name,
                    // title: item.title,
                    // type: item.type,
                    // objectId: item.objectId,
                    // relatedObject: item.relatedObject,
                    ...item,
                    name: this.isTenantApp ? item.name.replace(reg, '') : item.name,
                    defaultValue: this.setDefaultValue(item.type, item.defaultValue),
                }
                if (this.isTenantApp && !this.isTenantObject) {
                    this.apiParamObj.customizeType = this.validPurviewObject.customizeType
                    this.apiParamObj.customizeField = this.validPurviewObject.customizeField
                }
            } else {
                this.apiParamObj = {
                    ...this.apiParamObj,
                    type: STRING,
                }
            }
            if (this.isTenantApp) {
                this.apiParamObj.isTenant = true
            }
        },
        setDefaultValue(type, defaultValue) {
            if (
                (type === 'dateTime' && defaultValue === '0000-00-00 00:00:00')
                || (type === 'date' && defaultValue === '0000-00-00')
                || (type === 'time' && defaultValue === '00:00:00')
            ) {
                defaultValue = ''
            }
            return defaultValue
        },
        resetDefaultValue() {
            let defaultValue = 0
            const { type, defaultValue: currentValue, typeObjectId } = this.apiParamObj
            if (this.apiParamObj.type.indexOf('Array')) {
                defaultValue = []
            }
            if (type === 'enumeration') {
                if (currentValue) {
                    if (Array.isArray(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = ''
                    }
                } else {
                    defaultValue = ''
                }
            }
            if (type === 'string') {
                if (currentValue) {
                    if (typeof currentValue === 'string') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = ''
                    }
                } else {
                    defaultValue = ''
                }
            }
            if (type === 'number') {
                if (currentValue) {
                    if (typeof currentValue === 'number') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        const numberic = Number(currentValue)
                        defaultValue = isNaN(numberic) ? 0 : Number(currentValue)
                    }
                } else {
                    defaultValue = 0
                }
            }
            if (type === 'dateTime') {
                const dateTimeReg = /^\d{4}-\d{2}-\d{2}\s*\d{2}:\d{2}:\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '0000-00-00 00:00:00'
                    }
                } else {
                    defaultValue = '' // '0000-00-00 00:00:00'
                }
            }
            if (type === 'date') {
                const dateTimeReg = /^\d{4}-\d{2}-\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '0000-00-00'
                    }
                } else {
                    defaultValue = '' // '0000-00-00'
                }
            }
            if (type === 'time') {
                const dateTimeReg = /^\d{2}:\d{2}:\d{2}$/gi
                if (currentValue) {
                    if (dateTimeReg.test(currentValue)) {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = '' // '00:00:00'
                    }
                } else {
                    defaultValue = '' // '00:00:00'
                }
            }
            if (type === 'boolean') {
                if (currentValue) {
                    if (typeof currentValue === 'boolean') {
                        defaultValue = this.apiParamObj.defaultValue
                    } else {
                        defaultValue = false
                    }
                } else {
                    defaultValue = false
                }
            }
            if (type === 'object') {
                defaultValue = {}
            }
            if (!typeObjectId) {
                this.apiParamObj.typeObjectId = ''
            }
            return defaultValue
        },
        async checkFielsPass() {
            // 产品应用字段、租户继承产品字段
            if (!this.isTenantObject) {
                const params = {
                    appId: this.appId,
                    ...this.commonParams,
                    objectField: this.apiParamObj.name,
                }
                // 租户应用
                if (this.isTenantApp) {
                    // 有权限方案
                    if (this.validPurviewObject.addField) {
                        params.customizeType = this.apiParamObj.customizeType
                        params.customizeField = this.apiParamObj.customizeField
                        // return this.checkCustomizeField(params)
                    }
                    return Promise.resolve(true)
                }
                // 产品引用
                // const objectData = await this.getPurviewObject({
                //     appId: this.appId,
                // })
                // 有权限方案
                // if (objectData.addField) {
                params.customizeType = this.apiParamObj.customizeType
                params.customizeField = this.apiParamObj.customizeField
                // return this.checkCustomizeField(params)
                // }
            }
            return Promise.resolve(true)
        },
        // 添加字段
        addObjectFieldFn(bool) {
            this.rulesObj = { ...this.rulesObj, ...this.defaultValRules }
            // 优先校验子表单数据
            this.$refs.objectDetailTypeForm.validateChildForm(val => {
                if (val) {
                    this.$refs.form.validate(async valid => {
                        if (valid) {
                            try {
                                const defaultValue = this.resetDefaultValue()

                                // const checkPass = await this.checkFielsPass()
                                // if (!checkPass) {
                                //     this.$message.error('该字段已被使用，不可重复注册')
                                //     return
                                // }
                                await this.addObjectField({
                                    objectId: this.objectId,
                                    params: {
                                        ...this.apiParamObj,
                                        defaultValue,
                                    },
                                })
                                const defaultType = STRING
                                this.apiParamObj = {
                                    type: defaultType,
                                    config: DefaultTypeValue[defaultType],
                                    relatedObject: {},
                                }
                                this.$message.success('新增成功')
                                this.getObjectFieldFn()
                                if (!bool) {
                                    this.$set(this.varObj, 'optBool', false)
                                    this.cancel()
                                } else if (this.isTenantApp) {
                                    if (!this.isTenantObject) {
                                        this.apiParamObj = {
                                            ...this.apiParamObj,
                                            customizeType: this.validPurviewObject.customizeType,
                                            customizeField: this.validPurviewObject.customizeField,
                                        }
                                    }
                                    this.apiParamObj.isTenant = true
                                }
                                // eslint-disable-next-line no-empty
                            } catch (error) {}
                        }
                    })
                }
            })
        },
        // 编辑字段
        editObjectFieldFn() {
            // 优先校验子表单数据
            this.$refs.objectDetailTypeForm.validateChildForm(val => {
                if (val) {
                    this.$refs.form.validate(async valid => {
                        if (valid) {
                            try {
                                const defaultValue = this.resetDefaultValue()
                                // const checkPass = await this.checkFielsPass()
                                // if (!checkPass) {
                                //     this.$message.error('该字段已被使用，不可重复注册')
                                //     return
                                // }

                                console.log(this.apiParamObj)

                                await this.editObjectField({
                                    objectId: this.objectId,
                                    fieldId: this.varObj.fieldId,
                                    params: {
                                        ...this.apiParamObj,
                                        defaultValue,
                                    },
                                })
                                this.$message.success('编辑成功')
                                this.getObjectFieldFn()
                                this.$set(this.varObj, 'optBool', false)
                                this.cancel()
                                // eslint-disable-next-line no-empty
                            } catch (error) {}
                        }
                    })
                }
            })
        },
        // 删除字段
        delObjectFieldFn(row) {
            this.$confirm('字段删除后将无法恢复，确定删除？', {
                type: 'warning',
                title: '删除字段',
                customClass: 'confirm-box',
                roundButton: false,
                closeOnClickModal: false,
            }).then(async () => {
                try {
                    await this.delObjectField({
                        objectId: this.objectId,
                        fieldId: row.id,
                    })
                    this.$message.success('删除成功')
                    this.getObjectFieldFn()
                // eslint-disable-next-line no-empty
                } catch (error) {}
            }).catch(() => {})
        },
        objectDetailFn(obj) {
            this.isTenantObject = obj.isTenant

            this.$router.push({ name: RouteNames.OBJECT_DETAIL, params: { objectId: obj.id, objectName: obj.title } })
        },
        changeFieldTypeFn() {
            this.$set(this.apiParamObj, 'defaultValue', '')
        },
    },
}
</script>
<style lang="less">
.confirm-box{
    .hc-button{
        border-radius: 4px;
        width: 88px;
        height: 32px;
    }
}
</style>
<style lang="less" scoped>
@import '../../../assets/less/var.less';
    @deep: ~'>>>';
    .custom-table {
        padding: 16px 16px 0;
        overflow: auto;
    }

    /deep/ .hc-table__fixed-right,
    /deep/ .hc-table__fixed{
        height: 100% !important;
        top: 16px;
    }
    .new-object{
        @{deep} .common-container__body {
            padding: 0 24px 24px 24px;
        }
        .info-title {
            color: #222;
            font-size: 12px;
            font-weight: 700;
            padding: 14px 16px;
            line-height: 20px;
            border-bottom: 1px solid #E9EBEE;
        }
        .object-info {
            background: #fff;
            .info-content {
                display: flex;
                padding: 18px 16px;
            }
            .info-item {
                flex-shrink: 0;
                display: flex;
                line-height: 20px;
                align-items: center;
                font-size: 12px;
                &:not(:first-child) {
                    margin-left: 24px;
                }
                &.remark {
                    flex: 1;
                    display: flex;
                    overflow: hidden;
                    h4 {
                        flex-shrink: 0;
                    }
                    p {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                h4 {
                    font-weight: 400;
                    display: inline-block;
                    color: #999;
                }
                p {
                    color: #222;
                }
            }
        }
        &__group{
            // padding: 8px 16px;
            // height: 48px;
            // line-height: 48px;
            margin-top: 16px;
            display: flex;
            align-items: center;
            background: #fff;
            justify-content: space-between;
            &__btn{
                &--add{
                    width:88px;
                    display: inline-block;
                    text-align: center;
                    height:36px;
                    color:#FFF;
                    line-height: 36px;
                    border-radius:4px;
                    cursor: pointer;
                    font-size: 14px;
                }
            }
        }
        @{deep} .hc-dialog__header{
            background: #fff;
            height: 56px;
            .hc-dialog__headerbtn{
                right: 20px;
                top: 18px;
            }
        }
        @{deep} .hc-dialog__body{
            // padding:24px 40px;
            .hc-select{
                display: block;
            }
        }
        @{deep} .hc-dialog__footer{
            // height: 79px;
            // line-height: 79px;
            // padding:0 24px;
            .hc-button--plain{
                width: 88px;
                color:rgba(62, 67, 82, 1);
                border-radius: 4px;
            }
            .hc-button--primary{
                border-radius: 4px;
            }
        }
    }
</style>
